<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>hms</span>
        <span class="font-weight-light">tool</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="selectPlanDialog" width="500">
        <template v-slot:activator="{ on }">
          <v-btn
            color="green lighten-2"
            dark
            v-show="
              $route.name == 'dashboard' && GET_PLANSFORTHISCUSTOMER.length > 0
            "
            v-on="on"
          >
            {{
              manuallySelectedPlan
                ? GET_PLANSFORTHISCUSTOMER.filter(
                    (el) => el.id == manuallySelectedPlan
                  ).pop().year
                : "Velg plan"
            }}</v-btn
          >
        </template>
        <v-card class="pa-3">
          <h2>Velg plan som du ønsker å vise på oversikten</h2>
          <v-btn
            v-for="selectplan in GET_PLANSFORTHISCUSTOMER"
            :key="selectplan.id"
            @click="manuallySelectedPlan = selectplan.id"
            block
            class="pa-1"
            :class="{ success: manuallySelectedPlan == selectplan.id }"
            >{{ selectplan.title }} {{ selectplan.year }}</v-btn
          >
        </v-card>
      </v-dialog>
      <template v-if="GET_USER">
        <v-btn :to="{ name: 'dashboard' }">Oversikt</v-btn>
        <v-btn
          v-for="(menu, menukey) in menuFiltered"
          :key="menukey"
          :to="menu.to"
          >{{ menu.title }}</v-btn
        >
        <v-btn @click="openPDFWindow">UTSKRIFT PLAN</v-btn>
        <v-btn @click="logout"
          >Logg ut {{ GET_USER.name || GET_USER.username }}</v-btn
        >
      </template>
      <v-dialog
        v-model="loginDialog"
        width="500"
        @keydown.esc="cancelLogin"
        persistent
      >
        <template v-slot:activator="{ on }">
          <v-btn color="red lighten-2" v-show="!GET_USER" dark v-on="on"
            >Login</v-btn
          >
        </template>
        <v-card>
          <v-form @submit.prevent="login">
            <v-card-text>
              <v-text-field
                :label="GET_ORDLYD && GET_ORDLYD.username"
                v-model="loginData.username"
                append-icon="person"
                required
              ></v-text-field>
              <v-text-field
                :label="GET_ORDLYD && GET_ORDLYD.password"
                v-model="loginData.password"
                required
                :append-icon="showpassword ? 'visibility' : 'visibility_off'"
                @click:append="showpassword = !showpassword"
                :type="showpassword ? 'text' : 'password'"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" flat="flat" type="submit"
                >Login</v-btn
              >
              <v-btn color="grey" flat="flat" @click.native="cancelLogin"
                >Avbryt</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-content>
      <v-dialog v-model="printPDFDialog" v-if="plan" fullscreen>
        <v-card>
          <v-toolbar fixed>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="generatePDF">LAG PDF</v-btn>
            <v-btn color="error" flat @click="printPDFDialog = false"
              >LUKK SIDEN</v-btn
            >
          </v-toolbar>
          <div id="pdfContainer" style="margin-top: 100px; width:1000px">
            <div id="pdf_hms" style="margin:20px; ">
              <v-layout row wrap>
                <v-flex xs4 offset-xs4>
                  <img src="/logo_verdal-500x271.png" style="width:100%;" />
                </v-flex>
              </v-layout>
              <p class="headline">{{ planTitle }}</p>

              <v-layout row wrap>
                <v-flex xs12 pt-3>
                  <v-card>
                    <v-card-text
                      style="min-height: 200px; font-size:1.5em;"
                      v-html="planDescription"
                    ></v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 pt-3>
                  <v-card>
                    <v-layout row wrap pa-2>
                      <v-flex xs12 sm3 pb-0>
                        <v-text-field
                          :value="Response.ParentOrg"
                          :hint="GET_ORDLYD && GET_ORDLYD.org_area"
                          persistent-hint
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 pb-0>
                        <v-text-field
                          :value="Response.Org"
                          :hint="GET_ORDLYD && GET_ORDLYD.org_department"
                          persistent-hint
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 pb-0>
                        <v-text-field
                          :value="Response.Place"
                          persistent-hint
                          :hint="GET_ORDLYD && GET_ORDLYD.place"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm3 pb-0>
                        <v-text-field
                          :value="Response.Date"
                          persistent-hint
                          :hint="GET_ORDLYD && GET_ORDLYD.date"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 pt-0>
                        <v-text-field
                          :value="Response.Participants"
                          persistent-hint
                          :hint="GET_ORDLYD && GET_ORDLYD.help_participiants"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
            <div id="pdf_guide" style="margin:20px; font-size:1.5em;">
              <p class="headline">Veiledning</p>
              <div
                v-html="plan && plan.planning && plan.planning.veiledning"
              ></div>
            </div>

            <div id="pdf_evaluations" style="margin:20px; font-size:1.5em;">
              <p class="headline">
                {{ GET_ORDLYD && GET_ORDLYD.evaluering_overskrift }}
              </p>

              <v-layout
                row
                wrap
                v-for="task in plan.evaluationtasks"
                :key="task.id"
                justify-center
                align-space-around
                class="mb-3"
              >
                <v-flex xs8 d-flex align-center px-2>
                  <span v-text="task.question"></span>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                  <input type="checkbox" :checked="task.completed == 1" />
                  <label
                    style="color: black; margin-left: 10px; margin-right: 10px; "
                    >Ja</label
                  >
                  <input type="checkbox" :checked="task.completed == 2" />
                  <label style="color: black; margin-left: 10px; ">Nei</label>
                </v-flex>

                <v-flex xs12>
                  <v-textarea
                    persistent-hint
                    hint="Kommentar"
                    :value="task.text"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </div>
            <div id="pdf_targets" style="margin:20px; font-size:1.5em;">
              <p class="headline">Overordna mål</p>

              <v-layout row wrap>
                <v-flex xs12 pt-3>
                  <div
                    v-html="
                      plan &&
                        plan.planning &&
                        plan.planning.overordna_maalsetting
                    "
                  ></div>
                </v-flex>
                <v-flex xs12 pt-3>
                  <div
                    v-html="
                      plan && plan.planning && plan.planning.avd_maalsetting
                    "
                  ></div>
                </v-flex>
              </v-layout>
            </div>
            <div id="pdf_avd_targets" style="margin:20px; font-size:1.5em;">
              <p class="headline">Avdelingens mål</p>

              <v-layout row wrap>
                <v-flex xs12 sm6 pt-3>
                  <v-textarea
                    :hint="GET_ORDLYD && GET_ORDLYD.org_avdeling_target"
                    persistent-hint
                    :value="Response.avd_maal_frafall_reduksjon"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm6 pt-3>
                  <v-textarea
                    :hint="GET_ORDLYD && GET_ORDLYD.org_avdeling_subtarget"
                    persistent-hint
                    :value="Response.avd_delmaal_frafall_reduksjon"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 pt-3>
                  <v-layout
                    style="font-size: 0.8em; border-bottom: 1px solid black; font-weight: 700"
                  >
                    <v-flex xs6>{{
                      GET_ORDLYD &&
                        GET_ORDLYD.org_avdeling_tilstedeverelse_target
                    }}</v-flex>
                    <v-flex xs6>{{
                      GET_ORDLYD &&
                        GET_ORDLYD.org_avdeling_tilstedeverelse_target_short
                    }}</v-flex>
                  </v-layout>
                  <v-layout
                    v-for="(item, index) in absenceGoals"
                    :key="item.abbreviation"
                    style="font-size: 0.8em; border-bottom: 1px solid black;"
                  >
                  
                  <v-flex xs6 v-if="plan.planning !== undefined && index <= 2">Måltall {{ Number(plan.planning.year) + 2 - index}} </v-flex> 
                  <v-flex xs6 v-if="plan.planning !== undefined && index > 2">Nærvær {{ Number(plan.planning.year) + 2 - index}}</v-flex> 
                    <!-- <v-flex xs6>{{ item.label }}</v-flex> -->
                    <v-flex xs6>{{
                      Number(item.shortabsence).toFixed(2) + " %"
                    }}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div id="pdf_activities" style="margin:20px; font-size:1.5em;">
              <h2 pt-3>{{ GET_ORDLYD && GET_ORDLYD.org_overview }}</h2>
              <v-data-table
                class="overordna_aktivitet"
                :items="overordna_aktivitet"
                hide-actions
              >
                <template v-slot:headers>
                  <tr>
                    <th align="left" style="width: 20%;">
                      {{ GET_ORDLYD && GET_ORDLYD.schedule }}
                    </th>
                    <th align="left" style="width: 15%;">
                      {{ GET_ORDLYD && GET_ORDLYD.category }}
                    </th>
                    <th style="width:40%;" align="left">
                      {{ GET_ORDLYD && GET_ORDLYD.measure }}
                    </th>
                    <th align="left">
                      {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
                    </th>
                  </tr>
                </template>
                <template v-slot:no-data>
                  <tr v-for="n in 5" :key="n">
                    <td v-for="x in 4" :key="x"></td>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr>
                    <td>{{ props.item.schedule }}</td>
                    <td>{{ props.item.category }}</td>
                    <td>{{ props.item.measure }}</td>
                    <td>{{ props.item.responsibility }}</td>
                  </tr>
                </template>
              </v-data-table>
              <h2>
                {{ GET_ORDLYD && GET_ORDLYD.org_avdeling_mandatory_activities }}
              </h2>
              <v-data-table
                class="avd_aktivitet"
                :items="avd_aktivitet"
                hide-actions
              >
                <template v-slot:headers>
                  <th align="left" style="width: 20%;">
                    {{ GET_ORDLYD && GET_ORDLYD.schedule }}
                  </th>
                  <th align="left" style="width: 15%;">
                    {{ GET_ORDLYD && GET_ORDLYD.category }}
                  </th>
                  <th style="width:40%;" align="left">
                    {{ GET_ORDLYD && GET_ORDLYD.measure }}
                  </th>
                  <th align="left">
                    {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
                  </th>
                </template>
                <template v-slot:items="props">
                  <tr>
                    <td>{{ props.item.schedule }}</td>
                    <td>{{ props.item.category }}</td>
                    <td>{{ props.item.measure }}</td>
                    <td>{{ props.item.responsibility }}</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <div id="pdf_area_activities" style="margin:20px; font-size:1.5em;">
              <h2>
                {{ GET_ORDLYD && GET_ORDLYD.org_avdeling_other_activities }}
              </h2>

              <v-data-table
                class="avd_ovrige_aktiviter"
                :items="Response.avd_ovrige_aktiviter"
                hide-actions
              >
                <template v-slot:headers>
                  <th style="width: 20%;" align="left">
                    {{ GET_ORDLYD && GET_ORDLYD.schedule }}
                  </th>
                  <th style="width: 15%;" align="left">
                    {{ GET_ORDLYD && GET_ORDLYD.category }}
                  </th>
                  <th align="left">{{ GET_ORDLYD && GET_ORDLYD.measure }}</th>
                  <th style="width:15%;" align="left">
                    {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
                  </th>
                </template>

                <template v-slot:items="props">
                  <td>{{ props.item.schedule }}</td>
                  <td>{{ props.item.category }}</td>
                  <td>{{ props.item.measure }}</td>
                  <td>{{ props.item.responsibility }}</td>
                </template>
                <template v-slot:no-data>
                  <tr v-for="n in 5" :key="n">
                    <td v-for="x in 4" :key="x"></td>
                  </tr>
                </template>
              </v-data-table>
              <h2>
                {{ GET_ORDLYD && GET_ORDLYD.org_avdeling_hms_activities }}
              </h2>
              <v-data-table
                class="bruk_av_hms_og_als"
                :items="Response.bruk_av_hms_og_als"
                hide-actions
              >
                <template v-slot:headers>
                  <th style="width: 20%;" align="left">
                    {{ GET_ORDLYD && GET_ORDLYD.schedule }}
                  </th>
                  <th style="width: 15%;" align="left">
                    {{ GET_ORDLYD && GET_ORDLYD.category }}
                  </th>
                  <th align="left">{{ GET_ORDLYD && GET_ORDLYD.measure }}</th>
                  <th style="width:15%;" align="left">
                    {{ GET_ORDLYD && GET_ORDLYD.responsibility }}
                  </th>
                </template>
                <template v-slot:no-data>
                  <tr v-for="n in 5" :key="n">
                    <td v-for="x in 4" :key="x"></td>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <td>{{ props.item.schedule }}</td>
                  <td>{{ props.item.category }}</td>

                  <td>{{ props.item.measure }}</td>

                  <td>{{ props.item.responsibility }}</td>
                </template>
              </v-data-table>
            </div>
            <div id="pdf_resources" style="margin:20px; font-size:1.5em;">
              <v-card>
                <v-card-title>{{
                  GET_ORDLYD && GET_ORDLYD.fagressurser
                }}</v-card-title>
                <v-card-text>
                  <table style="width: 100%; border-collapse: collapse; ">
                    <tr>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                            GET_ORDLYD.fagressurser_kode.toUpperCase()
                        }}
                      </th>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                            GET_ORDLYD.fagressurser_beskrivelse.toUpperCase()
                        }}
                      </th>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                            GET_ORDLYD.fagressurser_kontakt.toUpperCase()
                        }}
                      </th>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                            GET_ORDLYD.fagressurser_epost.toUpperCase()
                        }}
                      </th>
                      <th align="left">
                        {{
                          GET_ORDLYD &&
                            GET_ORDLYD.fagressurser_telefon.toUpperCase()
                        }}
                      </th>
                    </tr>
                    <tr
                      v-for="resource in plan.resources"
                      :key="resource.abbreviation"
                      style="font-size: 0.8em;"
                    >
                      <td
                        style="padding:10px; outline: 1px solid black; outline-offset: -2px;"
                      >
                        {{ resource.abbreviation }}
                      </td>
                      <td
                        style="padding:10px; outline: 1px solid black; outline-offset: -2px;"
                      >
                        {{ resource.description }}
                      </td>
                      <td
                        style="padding:10px; outline: 1px solid black; outline-offset: -2px;"
                      >
                        {{ resource.contact }}
                      </td>
                      <td
                        style="padding:10px; outline: 1px solid black; outline-offset: -2px;"
                      >
                        {{ resource.email }}
                      </td>
                      <td
                        style="padding:10px; outline: 1px solid black; outline-offset: -2px;"
                      >
                        {{ resource.phone }}
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loadingDialog" persistent>
        <v-card>
          <v-card-text class="headline">
            Vennligst vent.
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-dialog>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>
<style scoped>
.theme--light.v-input >>> .v-messages__message {
  color: black;
  font-size: 14px;
}
.theme--light.v-table thead th {
  color: black;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
export default {
  name: "App",
  components: {},
  watch: {
    manuallySelectedPlan(val) {
      if (val) {
        this.SET_MANUALLYSELECTEDPLAN(val);
        this.selectPlanDialog = false;
      }
    },
    GET_MANUALLYSELECTEDPLAN(val, oldval) {
      if (!val) {
        this.manuallySelectedPlan = 0;
      }
    },
  },
  data() {
    console.log('RESPONSE PLANNINGID', this.manuallySelectedPlan )
    return {
      manuallySelectedPlan: 0,
      allplans: [],
      showpassword: false,
      loginDialog: false,
      selectPlanDialog: false,
      printPDFDialog: false,
      loginData: {
        username: "",
        password: "",
      },
      roles: ["superadmin", "admin", "manager"],

      maanedsvalg: [
        "Månedlig",
        "Jevnlig",
        "Januar",
        "Februar",
        "Mars",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Desember",
      ],
      Response: {
        planningid: 0,
        ParentOrg: "",

        Org: "",
        Place: "",
        Date: null,
        Participants: "",
        avd_ovrige_aktiviter: [],
        bruk_av_hms_og_als: [],
        avd_maal_frafall_reduksjon: "",
        avd_delmaal_frafall_reduksjon: "",
        org_id: 0,
        sector_id: 0,
        area_id: 0,
      },
      absenceHeaders: [],
      absenceGoals: [
        {
          name: "targetnumber3years",
          label: "Måltall 2026",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "targetnumber2years",
          label: "Måltall 2025",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "targetnumber1years",
          label: "Måltall 2024",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "absencecurrenthalfyear",
          label: "Nærvær 2023",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "absence1years",
          label: "Nærvær 2022",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
        {
          name: "absence2years",
          label: "Nærvær 2021",
          shortabsence: 100,
          longabsence: 100,
          shorteditmode: false,
          longeditmode: false,
        },
      ],
      DateMenu: false,
      loadingDialog: false,
      registeredchanges: false,
      planDataIsRetrieved: false,
      plan: {},
      planTitle: "",
      planDescription: "",
      planOverordnaMaal: "",
      planAvdMaal: "",
      newEvaluation: "",

      newSchedule_bruk_av_hms_og_als: "",
      newMeasure_bruk_av_hms_og_als: "",
      newCategory_bruk_av_hms_og_als: "",
      newResponsibility_bruk_av_hms_og_als: "",
      newCategoryMenu_bruk_av_hms_og_als: false,
      newSchedule_avd_ovrige_aktiviter: "",
      newMeasure_avd_ovrige_aktiviter: "",
      newCategory_avd_ovrige_aktiviter: "",
      newResponsibility_avd_ovrige_aktiviter: "",
      newCategoryMenu_avd_ovrige_aktiviter: false,
    };
  },
  computed: {
    ...mapGetters([
      "GET_USER",
      "GET_TOKEN",
      "GET_ORDLYD",
      "GET_MANUALLYSELECTEDPLAN",
      "GET_PLANSFORTHISCUSTOMER",
    ]),

    menuItems() {
      return [
        {
          title: "Kunder",
          to: { name: "editcustomers" },
          reqRole: ["superadmin"],
        },
        {
          title: "Din profil",
          to: { name: "editprofile" },
          reqRole: ["admin"],
        },
        {
          title: "plan",
          to: { name: "plan" },
          reqRole: ["admin"],
        },
        {
          title: "plan",
          to: { name: "planresponse" },
          reqRole: ["user"],
        },
        {
          title: "rapport",
            to: { name: "report", params: { guid: this.manuallySelectedPlan }},
          reqRole: ["user"],
        },
      ]
    },
    menuFiltered() {
      let _CurrentRole = this.GET_USER.role;
      return this.menuItems.filter(
        (res) =>
          res.reqRole.includes("public") || res.reqRole.includes(_CurrentRole)
      );
    },
    overordna_aktivitet() {
      return (
        (this.plan &&
          this.plan.activities &&
          this.plan.activities.filter((res) => res.level == "kommune")) ||
        []
      );
    },
    avd_aktivitet() {
      return (
        (this.plan &&
          this.plan.activities &&
          this.plan.activities.filter((res) => res.level == "avdeling")) ||
        []
      );
    },
  },
  methods: {
    ...mapActions([
      "SUBMIT_LOGIN",
      "SUBMIT_LOGIN_TOKEN",
      "SUBMIT_LOGOUT",
      "FETCH_ORDLYD",
      "GET_USER_PLAN",
      "GET_PLAN",
      "GET_PLANS",
      "SET_MANUALLYSELECTEDPLAN",
      "GET_CURRENT_ACTIVE_PLAN",
    ]),
    cancelLogin() {
      this.loginDialog = false;
      this.loginData.username = "";
      this.loginData.password = "";
    },
    logout() {
      this.SUBMIT_LOGOUT().then((resp) => {
        setTimeout(() => this.$router.push("/"), 600);
      });
    },
    login() {
      this.loginData.password = this.loginData.password.toLowerCase();
      this.loginData.username = this.loginData.username.toLowerCase();
      this.SUBMIT_LOGIN(this.loginData)
        .then((resp) => {
          this.loginDialog = false;
          this.loginData.username = "";
          this.loginData.password = "";
          
          // if(this.GET_USER.role.toLowerCase() == "admin") {
          //   this.$router.push({
          //     name: "plan"
          //   });
          // }
          if(this.GET_USER.role.toLowerCase() == "user") {
            this.$router.push({
              name: "planresponse"
            });
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Kunne ikke logge inn");
        });
    },
    openPDFWindow() {
      this.getData()
        .then(() => {
          this.printPDFDialog = true;
        })
        .catch(() => {
          alert("Kunne ikke hente inn data");
        });
    },
    async generatePDF() {
      if (this.loadingDialog) {
        return;
      }
      this.loadingDialog = true;
      setTimeout(() => {
        let slides = [];

        // slides.push({ element: document.getElementById("pdfContainer") });
        // slides.push({ element: document.getElementById("pdfContainer") });

        slides.push({ element: document.getElementById("pdf_hms") });
        slides.push({ element: document.getElementById("pdf_guide") });
        slides.push({ element: document.getElementById("pdf_evaluations") });
        slides.push({ element: document.getElementById("pdf_targets") });
        slides.push({ element: document.getElementById("pdf_avd_targets") });
        slides.push({ element: document.getElementById("pdf_activities") });
        slides.push({
          element: document.getElementById("pdf_area_activities"),
        });

        slides.push({ element: document.getElementById("pdf_resources") });

        let _PromiseArray = [];
        for (var i = 0; i < slides.length; i++) {
          let _currentSlide = slides[i];
          _PromiseArray.push(html2canvas(_currentSlide.element, { scale: 3 }));
        }
        // slides.forEach(el => {
        //   _PromiseArray.push(html2canvas(el.element, { scale: 2 }));
        // });

        Promise.all(_PromiseArray).then((canvases) => {
          var pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
          pdf.setFontSize(14);
          var width = pdf.internal.pageSize.getWidth();
          var height = pdf.internal.pageSize.getHeight();
          let _remainingPage = 0;
          for (var i = 0; i < slides.length; i++) {
            _remainingPage = height - 20;
            let _currentSlide = slides[i];
            let canvas = canvases[i];
            _currentSlide.imgdata = canvas.toDataURL("image/jpeg", 1.0);
            _currentSlide.ratio = canvas.width / canvas.height;
            _currentSlide.imgheight = width / _currentSlide.ratio;
            let thisImgHeight = _currentSlide.imgheight - 30;

            if (_remainingPage - _currentSlide.imgheight < 0) {
              thisImgHeight = _remainingPage;
            }
            _remainingPage -= thisImgHeight;
            pdf.addImage(
              _currentSlide.imgdata,
              "JPEG",
              10,
              10,
              width - 20,
              thisImgHeight
            );
            pdf.text(i + 1 + " / " + slides.length, width - 20, height - 1);
            if (i < slides.length - 1) {
              pdf.addPage();
            }
          }
          pdf.save("plan_utskrift.pdf");
          this.loadingDialog = false;
        });
      }, 1000);
    },
    getData() {
      return new Promise((resolve, reject) => {
        switch (this.GET_USER.role.toLowerCase()) {
          case "admin":
            this.getOverorndaData()
              .then(() => resolve())
              .catch((err) => reject("feil"));
            break;
          case "user":
            this.getAvdData()
              .then(() => resolve())
              .catch((err) => reject("feil"));
            break;
          default:
            reject("feil");
        }
      });
    },
    getOverorndaData() {
      return new Promise((resolve, reject) => {
        this.GET_PLANS()
          .then((res) => {
            if (this.manuallySelectedPlan) {
              this.plans = this.allplans.filter(
                (el) => el.id == this.manuallySelectedPlan
              );
            } else {
              this.plans = res.data.planning.filter((el) => el.active == 1);
            }

            if (this.plans.length == 1) {
              this.GET_PLAN(this.plans[0].id)
                .then((res) => {
                  this.plan = res.data;
                  this.plan.activities.forEach((element) => {
                    element.kategori_meny = false;
                  });

                  this.planDataIsRetrieved = true;
                  this.planTitle = this.plan.planning["title"];
                  this.planDescription = this.plan.planning["description"];
                  // this.rapportoblaktiviteter = this.setrapportoblaktiviteter();
                  // this.rapportovrigeaktiviteter = this.setrapportovrigeaktiviteter();
                  // this.rapportbrukavhmsogalsaktiviteter = this.setrapportbrukavhmsogalsaktiviteter();
                  // this.rapportevaluering = this.setrapportevaluering();
                  resolve("ok");
                })
                .catch((e) => {
                  console.error(e);
                  reject("feil funnet");
                });
            } else {
              reject("feil funnet");
            }
          })
          .catch(() => {
            reject("feil funnet");
          });
      });
    },
    getAvdData() {
      return new Promise(async (resolve, reject) => {
        await this.GET_PLANS()
          .then((res) => {
            this.allplans = res.data.planning;
          })
          .catch(() => {
            reject("feil funnet");
          });
        this.GET_USER_PLAN(this.manuallySelectedPlan)
          .then((res) => {
            this.plan = res.data;
            this.plan.activities = this.plan.activities.map((res) => {
              return {
                ...res,
                schedule: res.responseschedule
                  ? res.responseschedule
                  : res.schedule,
                category: res.responsecategory
                  ? res.responsecategory
                  : res.category,

                DateMenu: false,
                responsedonedate: res.responsedonedate
                  ? res.responsedonedate.slice(0, 10)
                  : res.responsedate,
                CategoryMenu_avd_aktivitet: false,
                CategoryMenu_avd_ovrige_aktiviter: false,
                CategoryMenu_bruk_av_hms_og_als: false,
              };
            });
            for (var i = 0; i < 3; i++) {
              this.plan.custom_activities.push({
                responselevel: "avd_ovrige_aktiviter",
              });
            }
            for (var i = 0; i < 3; i++) {
              this.plan.custom_activities.push({
                responselevel: "bruk_av_hms_og_als",
              });
            }
            this.Response.avd_ovrige_aktiviter = this.plan.custom_activities
              .filter(
                (element) => element.responselevel == "avd_ovrige_aktiviter"
              )
              .map((element) => {
                return {
                  id: element.id,
                  schedule: element.responseschedule,
                  category: element.responsecategory,
                  measure: element.responsemeasure,
                  responsibility: element.responseresponsibility,
                  responsedone: element.responsedone,
                  respsonedonedate: element.responsedonedate,
                  level: element.responselevel,
                };
              });

            this.Response.bruk_av_hms_og_als = this.plan.custom_activities
              .filter(
                (element) => element.responselevel == "bruk_av_hms_og_als"
              )
              .map((element) => {
                return {
                  id: element.id,
                  schedule: element.responseschedule,
                  category: element.responsecategory,
                  measure: element.responsemeasure,
                  responsibility: element.responseresponsibility,
                  responsedone: element.responsedone,
                  respsonedonedate: element.responsedonedate,
                  level: element.responselevel,
                };
              });
            this.planTitle = this.plan.planning["title"];
            this.planDescription = this.plan.planning["description"].replace(
              "#avdeling#",
              this.plan.avdeling.label
            );
            this.Response.sector_id = this.plan.avdeling.sector_id;
            this.Response.area_id = this.plan.avdeling.area_id;
            this.Response.org_id = this.plan.avdeling.id;

            this.Response.planningid = this.plan.planning.id;
            this.Response.ParentOrg = this.plan.avdeling.area_label || "";
            this.Response.Org =
              (this.plan.avdeling && this.plan.avdeling.label) || "";

            this.Response.Date =
              (this.plan.planning.responsedate &&
                this.plan.planning.responsedate.slice(0, 10)) ||
              new Date().toISOString().slice(0, 10);
            this.Response.Place = this.plan.planning.responseplace || "";
            this.Response.Participants =
              this.plan.planning.responseparticipants || "";

            this.Response.avd_maal_frafall_reduksjon =
              (this.plan.response && this.plan.response.organisationtarget) ||
              "";
            this.Response.avd_delmaal_frafall_reduksjon =
              (this.plan.response &&
                this.plan.response.organisationsubtargets) ||
              "";

            let targetnumber3years = this.absenceGoals.find(
              (element) => element.name == "targetnumber3years"
            );
            targetnumber3years.longabsence =
              (this.plan.response &&
                this.plan.response.targetnumber3years_long) ||
              "100";
            targetnumber3years.shortabsence =
              (this.plan.response &&
                this.plan.response.targetnumber3years_short) ||
              "100";

            let targetnumber2years = this.absenceGoals.find(
              (element) => element.name == "targetnumber2years"
            );
            targetnumber2years.longabsence =
              (this.plan.response &&
                this.plan.response.targetnumber2years_long) ||
              "100";
            targetnumber2years.shortabsence =
              (this.plan.response &&
                this.plan.response.targetnumber2years_short) ||
              "100";

            let targetnumber1years = this.absenceGoals.find(
              (element) => element.name == "targetnumber1years"
            );
            targetnumber1years.longabsence =
              (this.plan.response &&
                this.plan.response.targetnumber1years_long) ||
              "100";
            targetnumber1years.shortabsence =
              (this.plan.response &&
                this.plan.response.targetnumber1years_short) ||
              "100";

            let absencecurrenthalfyear = this.absenceGoals.find(
              (element) => element.name == "absencecurrenthalfyear"
            );
            absencecurrenthalfyear.longabsence =
              (this.plan.response &&
                this.plan.response.absencecurrenthalfyear_long) ||
              "100";
            absencecurrenthalfyear.shortabsence =
              (this.plan.response &&
                this.plan.response.absencecurrenthalfyear_short) ||
              "100";

            let absence1years = this.absenceGoals.find(
              (element) => element.name == "absence1years"
            );
            absence1years.longabsence =
              (this.plan.response && this.plan.response.absence1years_long) ||
              "100";
            absence1years.shortabsence =
              (this.plan.response && this.plan.response.absence1years_short) ||
              "100";

            let absence2years = this.absenceGoals.find(
              (element) => element.name == "absence2years"
            );
            absence2years.longabsence =
              (this.plan.response && this.plan.response.absence2years_long) ||
              "100";
            absence2years.shortabsence =
              (this.plan.response && this.plan.response.absence2years_short) ||
              "100";

            this.plan.evaluationtasks.map((element) => {
              element.completed =
                element.completed == "1" ? 1 : element.completed == "2" ? 2 : 0;
              return element;
            });
            resolve("ok");
          })
          .catch((e) => {
            console.error(e);
            reject("feil funnet");
          });
      });
    },
  },
  mounted() {
    this.GET_CURRENT_ACTIVE_PLAN().then((res) => {
      this.manuallySelectedPlan = res;
      this.SET_MANUALLYSELECTEDPLAN(res);
    });
    this.GET_PLANS()
      .then((res) => {
        this.allplans = res.data.planning;
      })
      .catch(() => {
        reject("feil funnet");
      });

    this.FETCH_ORDLYD();

    if (localStorage.getItem("Token")) {
      this.SUBMIT_LOGIN_TOKEN()
        .then((resp) => {
          // setTimeout(() => this.$router.push("/"), 600);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
};
</script>
